module.exports = __webpack_public_path__ + "img/researchTrends_h6.558023da.jpg";